<template>
  <div class="components__rec-accordion">
    <div class="accordion-top" v-bind:class="expandedClass" v-on:click="toggle">
      <div class="accordion-title" v-bind:class="[themingCssClass('normal')]">
        {{ description.accordion_title }}
      </div>
      <div class="accordion-chevron" v-bind:class="[themingCssClass('normal')]">
        <i class="frontend-icon" v-bind:class="expandIconClass"></i>
      </div>
    </div>
    <div
      v-if="
        expanded &&
        description &&
        description.content &&
        description.content.component
      "
      class="accordion-content"
    >
      <component
        v-bind:is="description.content.component"
        v-bind:description="description.content"
        v-on:submit="$emit('submit')"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.components__rec-accordion {
  .accordion-top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    cursor: pointer;

    &.expanded {
      padding-bottom: 20px;
    }

    .accordion-chevron {
      font-size: 30px;
      height: 15px;

      > i {
        line-height: 15px;
      }
    }

    .accordion-title {
      font-size: 18px;
    }
  }
}
</style>

<script lang="ts" setup>
  import { computed, ref } from 'vue';
  
  import { themingCssClass } from "../../mixins/theming-mixin";
  import { recProps } from '../../mixins/rec-component';

  defineProps({...recProps()});

  const expanded = ref<boolean>(false);
  const expandIconClass = computed(()=> expanded.value ? "fi-expand_less" : "fi-expand_more");
  const expandedClass = computed(()=> expanded.value ? "expanded" : "retrieved");

  const toggle = () => { expanded.value = !expanded.value }
</script>
